import { render, staticRenderFns } from "./tier-list.vue?vue&type=template&id=638ff1cb"
import script from "./tier-list.vue?vue&type=script&lang=js"
export * from "./tier-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports